export default {
  box: {
    maximize: 'Maximieren',
    minimize: 'Verkleinern'
  }
}
